import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiMail, FiMapPin, FiGithub, FiLinkedin, FiTwitter } from 'react-icons/fi';
import './Contact.css';

const Contact = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 25 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const contactInfo = [
    { icon: <FiMail />, label: 'Email', value: 'gayatriduse99@gmail.com', href: 'mailto:gayatriduse99@gmail.com' },
    { icon: <FiMapPin />, label: 'Location', value: 'Nashik, Maharashtra', href: null },
  ];

  const socialLinks = [
    { icon: <FiGithub />, href: 'https://github.com/Gayatrii4506', label: 'GitHub' },
    { icon: <FiLinkedin />, href: 'https://www.linkedin.com/in/gayatri-duse/', label: 'LinkedIn' },
    { icon: <FiMail />, href: 'mailto:gayatriduse99@gmail.com', label: 'Gmail' },
  ];

  return (
    <section className="contact-section" id="contact" ref={ref}>
      <div className="section-container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          <motion.h2 className="section-title center" variants={itemVariants}>
            Get In Touch
          </motion.h2>

          <motion.p className="section-subtitle center contact-intro" variants={itemVariants}>
            I'm always open to discussing new opportunities, interesting projects, or just having a chat about technology. Feel free to reach out!
          </motion.p>

          <motion.div className="contact-info-side" variants={itemVariants}>
            <h3 className="contact-side-title">Let's Connect</h3>

            <div className="contact-cards">
              {contactInfo.map((info, i) => (
                <motion.div
                  key={i}
                  className="contact-info-card"
                  whileHover={{ y: -4 }}
                >
                  <div className="contact-info-icon">{info.icon}</div>
                  <div>
                    <span className="contact-info-label">{info.label}</span>
                    {info.href ? (
                      <a href={info.href} className="contact-info-value">{info.value}</a>
                    ) : (
                      <span className="contact-info-value">{info.value}</span>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="contact-social-section">
              <span className="contact-social-label">Follow Me</span>
              <div className="contact-social-links">
                {socialLinks.map((link, i) => (
                  <motion.a
                    key={i}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                    aria-label={link.label}
                    whileHover={{ y: -4, scale: 1.1 }}
                  >
                    {link.icon}
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;